module.exports = __webpack_public_path__ + "static/media/women-user-default.5f3223dc.png";